import { NoDataSize } from '@zaoblako/web/shared/components/no-data/constants/no-data-types.enum';

export type NoDataSizeConfigType = { [key: string]: { height: number; width: number } };
export const NO_DATA_SIZES_CONFIG: NoDataSizeConfigType = {
  [NoDataSize.XS]: {
    height: 1.5,
    width: 2
  },
  [NoDataSize.S]: {
    height: 4.5,
    width: 5
  },
  [NoDataSize.M]: {
    height: 6.5,
    width: 7
  },
  [NoDataSize.L]: {
    height: 7.5,
    width: 8
  },
  [NoDataSize.XL]: {
    height: 8.5,
    width: 9
  }
};
